import { createSlotFill } from './components/Slot';

export const AppBarTabs = createSlotFill();
